export default __webpack_public_path__ + "static/media/Face-Mask-Blank-Background-With-Design-3.4fe9bd9b.png";